/**
 * Brava Custom JavaScript - Refactored
 * Cleaned up: Removed dead Yotpo widget manipulation code
 * Kept: All active business logic for color swatches, gallery, forms, etc.
 */

// ============================================================
// COLOR SWATCH SWITCHING ON PRODUCT CARDS
// Used in card-product1.liquid
// Swatches carry plain image URLs (img1/img2 + natural widths); the
// responsive srcset is rebuilt here instead of shipping pre-rendered
// base64 <img> markup in the HTML (which weighed ~5KB per swatch).
// ============================================================

// Build a card <img> from a Shopify CDN URL (the URL carries width=940;
// srcset swaps that param). sizes is copied from the image being replaced.
function build_card_swatch_img(url, natural_width, cls, sizes, alt) {
  if (!url) return null;
  const widths = [165, 360, 533, 720, 940].filter((w) => !natural_width || w <= natural_width);
  if (!widths.length) widths.push(natural_width);
  const img = document.createElement("img");
  img.src = url;
  img.srcset = widths.map((w) => url.replace(/([?&])width=\d+/, "$1width=" + w) + " " + w + "w").join(", ");
  if (sizes) img.sizes = sizes;
  img.className = cls;
  img.loading = "lazy";
  img.alt = alt || "";
  return img;
}

function on_card_color_option_click(card_pdt_id, color_option_dom) {

  // Load product card by ID
  let card_dom = document.querySelector("#" + card_pdt_id);
  if (!card_dom) return;

  // Initialize color option - mark selected
  for (let tmp_color_option_dom of card_dom.querySelectorAll(".option_item")) {
    tmp_color_option_dom.removeAttribute("active");
  }
  color_option_dom.setAttribute("active", true);

  // Update images from the swatch's URL attributes
  let first_product_img = card_dom.querySelector(".hdt-card-product__media--main");
  let second_product_img = card_dom.querySelector(".hdt-card-product__media--hover");
  let alt_title = color_option_dom.getAttribute("product_title") || "";
  let main_img = build_card_swatch_img(
    color_option_dom.getAttribute("img1"),
    parseInt(color_option_dom.getAttribute("img1w"), 10) || 0,
    "hdt-card-product__media--main",
    first_product_img ? first_product_img.getAttribute("sizes") : "",
    alt_title
  );
  if (first_product_img && main_img) first_product_img.replaceWith(main_img);
  let hover_img = build_card_swatch_img(
    color_option_dom.getAttribute("img2"),
    parseInt(color_option_dom.getAttribute("img2w"), 10) || 0,
    "hdt-card-product__media--hover",
    first_product_img ? first_product_img.getAttribute("sizes") : "",
    alt_title
  );
  if (hover_img) {
    if (second_product_img) second_product_img.replaceWith(hover_img);
    else if (main_img) main_img.after(hover_img);
  }

  // Update title & URL. The title is split into a brand line + name line
  // (see snippet 'card-brand-split'); update the two spans separately so the
  // structure survives a colour switch. Fall back to a plain textContent set
  // if the spans aren't present (a no-brand/fallback card structured as a bare
  // title). The swatch carries product_brand/product_name computed in Liquid.
  let product_title = card_dom.querySelector(".hdt-card-product__title");
  let name_el = product_title.querySelector(".hdt-card-product__name");
  let brand_el = product_title.querySelector(".hdt-card-product__brand");
  let new_brand = color_option_dom.getAttribute("product_brand") || "";
  let new_name = color_option_dom.getAttribute("product_name") || color_option_dom.getAttribute("product_title") || "";
  if (name_el) {
    name_el.textContent = new_name;
    if (brand_el) {
      if (new_brand) { brand_el.textContent = new_brand; brand_el.style.display = ""; }
      else { brand_el.style.display = "none"; }
    } else if (new_brand) {
      // no brand span existed but the new colour has a brand: prepend one
      let s = document.createElement("span");
      s.className = "hdt-card-product__brand";
      s.textContent = new_brand;
      product_title.insertBefore(s, name_el);
    }
  } else {
    product_title.textContent = color_option_dom.getAttribute("product_title");
  }
  product_title.setAttribute("href", color_option_dom.getAttribute("product_url"));

  // Update colour subline
  let colour_el = card_dom.querySelector(".hdt-card-product__colour");
  let new_colour = color_option_dom.getAttribute("product_colour") || "";
  if (colour_el) {
    if (new_colour) { colour_el.textContent = new_colour; colour_el.style.display = ""; }
    else { colour_el.style.display = "none"; }
  } else if (new_colour) {
    // Lands above the swatch row it names, not next to the title — see
    // card-product1.liquid / new-css.css for why the label lives here.
    let c = document.createElement("span");
    c.className = "hdt-card-product__colour";
    c.textContent = new_colour;
    let swatch_list = card_dom.querySelector(".color-option-list");
    if (swatch_list) swatch_list.parentNode.insertBefore(c, swatch_list);
  }

  // Update image link
  let img_link = card_dom.querySelector(".hdt-card-product__media-wrapp");
  img_link.setAttribute("href", color_option_dom.getAttribute("product_url"));

  // Update price block
  for (let price_block of card_dom.querySelectorAll(".price_list .price_block")) {
    if (price_block.getAttribute("product_handle") == color_option_dom.getAttribute("product_handle")) {
      price_block.setAttribute("active", true);
    } else {
      price_block.removeAttribute("active");
    }
  }

  // Update badges (theme New/Sale)
  for (let badge of card_dom.querySelectorAll(".badge_item")) {
    if (badge.getAttribute("product_handle") == color_option_dom.getAttribute("product_handle")) {
      badge.setAttribute("active", true);
    } else {
      badge.removeAttribute("active");
    }
  }

  // Update curated productBadges (Bestseller / Coming Soon / etc) — same handle swap
  for (let pb of card_dom.querySelectorAll(".custom-product-card-badge-list .custom-product-card-badge-wrapper")) {
    if (pb.getAttribute("product_handle") == color_option_dom.getAttribute("product_handle")) {
      pb.setAttribute("active", true);
    } else {
      pb.removeAttribute("active");
    }
  }

  // Update size list
  for (let size_list of card_dom.querySelectorAll(".size_list_block")) {
    if (size_list.getAttribute("product_handle") == color_option_dom.getAttribute("product_handle")) {
      size_list.setAttribute("active", true);
    } else {
      size_list.removeAttribute("active");
    }
  }

  // Update quick action buttons: rebuild the one set from the card's pristine
  // template with the tapped colour's id and handle (snippets/card-product1.liquid).
  // New elements re-run the wishlist/compare constructors, which read the id once
  // and set their own added state.
  let btns = card_dom.querySelector(".hdt-product-btns-group .hdt-product-btns");
  let btns_tpl = card_dom.querySelector(".hdt-product-btns-tpl");
  let new_handle = color_option_dom.getAttribute("product_handle");
  let new_id = color_option_dom.getAttribute("product_id");
  if (btns && btns_tpl && new_handle && new_id && btns.getAttribute("product_handle") !== new_handle) {
    btns.innerHTML = btns_tpl.innerHTML
      .split('"' + btns_tpl.dataset.id + '"').join('"' + new_id + '"')
      .split('"' + btns_tpl.dataset.handle + '"').join('"' + new_handle + '"');
    btns.setAttribute("product_handle", new_handle);
  }
}


// ============================================================
// CARD SWATCH PAGINATION
// The colour row on product cards shows as many swatches as fit. When
// there's more, the edge slot becomes a ‹/› button — a normal flex item
// the same size and position as a swatch, not an overlay, so it can never
// sit on top of one. No native scrolling is involved at all: everything
// outside the current "page" is display:none (fully out of layout, so no
// gaps or overlap), and paging just swaps which slice is visible. All
// colours stay real <a href> links in the DOM regardless of page, so every
// colour is reachable by crawlers/keyboard even when off-page.
// Delegated + observer-based so it survives AJAX-rendered grids (facet
// filtering, pagination).
// ============================================================
(function () {
  const SWATCH_STATE = new WeakMap(); // list element -> { start, capacity }

  function get_items(list) {
    return Array.prototype.filter.call(list.children, function (el) {
      return el.classList.contains("option_item_wrapper");
    });
  }

  // Work out which items are visible for a window anchored at `anchor`,
  // reserving a slot for an arrow on whichever side(s) still have content
  // beyond the window. anchor_is_start=true anchors the window's start
  // (paging forward); false anchors its end (paging backward).
  function fit_window(anchor, anchor_is_start, capacity, total) {
    if (anchor_is_start) {
      let has_prev = anchor > 0;
      let slots = Math.max(1, capacity - (has_prev ? 1 : 0));
      let end = Math.min(total, anchor + slots);
      let has_next = end < total;
      if (has_next) {
        slots = Math.max(1, capacity - (has_prev ? 1 : 0) - 1);
        end = Math.min(total, anchor + slots);
        has_next = end < total;
      }
      return { start: anchor, end: end, has_prev: has_prev, has_next: has_next };
    }
    let has_next = anchor < total;
    let slots = Math.max(1, capacity - (has_next ? 1 : 0));
    let start = Math.max(0, anchor - slots);
    let has_prev = start > 0;
    if (has_prev) {
      slots = Math.max(1, capacity - (has_next ? 1 : 0) - 1);
      start = Math.max(0, anchor - slots);
    }
    return { start: start, end: anchor, has_prev: has_prev, has_next: has_next };
  }

  // How many swatch-sized circles fit across the list's available width.
  function measure_capacity(list, items) {
    let sample = items[0].getBoundingClientRect().width;
    if (!sample) return items.length;
    let styles = getComputedStyle(list);
    let gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
    let unit = sample + gap;
    let available = list.clientWidth + gap;
    return Math.max(1, Math.floor(available / unit));
  }

  function render_window(list, win) {
    let items = get_items(list);
    items.forEach(function (item, i) {
      item.style.display = i >= win.start && i < win.end ? "" : "none";
    });
    let prev_btn = list.querySelector(".color-option-arrow--prev");
    let next_btn = list.querySelector(".color-option-arrow--next");
    if (prev_btn) prev_btn.classList.toggle("is-visible", win.has_prev);
    if (next_btn) {
      next_btn.classList.toggle("is-visible", win.has_next);
      // The forward button is a chevron ARROW (Jake: "it needs to be an
      // arrow, or else it doesn't look like it's clickable") with a small
      // notification-style bubble carrying the remaining-colour count —
      // the affordance and the information are separate elements, and the
      // count self-updates as you page.
      if (win.has_next) {
        let items2 = get_items(list);
        let remaining = items2.length - win.end;
        let bubble = next_btn.querySelector(".color-option-arrow__bubble");
        if (bubble) bubble.textContent = remaining;
        next_btn.setAttribute("aria-label", remaining + " more colours");
      }
    }
  }

  function layout_list(list) {
    let items = get_items(list);
    if (items.length < 2) return; // nothing to paginate
    let capacity = measure_capacity(list, items);
    let all_fit = items.length <= capacity;
    list.classList.toggle("is-paginated", !all_fit);
    if (all_fit) {
      items.forEach(function (item) { item.style.display = ""; });
      let prev_btn = list.querySelector(".color-option-arrow--prev");
      let next_btn = list.querySelector(".color-option-arrow--next");
      if (prev_btn) prev_btn.classList.remove("is-visible");
      if (next_btn) next_btn.classList.remove("is-visible");
      SWATCH_STATE.set(list, { start: 0, capacity: capacity });
      return;
    }
    let prior = SWATCH_STATE.get(list);
    let start = prior ? Math.min(prior.start, Math.max(0, items.length - 1)) : 0;
    let win = fit_window(start, true, capacity, items.length);
    render_window(list, win);
    SWATCH_STATE.set(list, { start: win.start, capacity: capacity });
  }

  function page(list, dir) {
    let items = get_items(list);
    let state = SWATCH_STATE.get(list);
    if (!state) return;
    let cur = fit_window(state.start, true, state.capacity, items.length);
    let win = dir > 0
      ? fit_window(cur.end, true, state.capacity, items.length)
      : fit_window(cur.start, false, state.capacity, items.length);
    render_window(list, win);
    SWATCH_STATE.set(list, { start: win.start, capacity: state.capacity });
  }

  let swatch_resize_observer = new ResizeObserver(function (entries) {
    for (let entry of entries) layout_list(entry.target);
  });

  function watch_swatch_lists() {
    for (let list of document.querySelectorAll(".color-option-list")) {
      if (list.dataset.swatchWatched) continue;
      list.dataset.swatchWatched = "1";
      // Don't rely solely on ResizeObserver's own async initial callback —
      // confirmed via testing that with many .color-option-list elements
      // observed in one page load, that first callback can report a stale/
      // wrong measurement for some of them (capacity computed too generous,
      // so a genuinely-overflowing row never got marked is-paginated and
      // just silently rendered all swatches wrapped instead). Running the
      // layout synchronously right here, at the moment each list is found
      // (after the DOM is already laid out), gives a reliable first answer;
      // the observer still catches any REAL later resize (viewport change,
      // sidebar toggle, etc).
      layout_list(list);
      swatch_resize_observer.observe(list);
    }
  }

  document.addEventListener("click", function (ev) {
    let btn = ev.target.closest(".color-option-arrow");
    if (!btn) return;
    ev.preventDefault();
    let list = btn.closest(".color-option-list");
    if (!list) return;
    page(list, btn.classList.contains("color-option-arrow--prev") ? -1 : 1);
  });

  function boot_swatch_pagination() {
    watch_swatch_lists();
    new MutationObserver(watch_swatch_lists).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot_swatch_pagination);
  } else {
    boot_swatch_pagination();
  }
})();


// ============================================================
// PRODUCT SIZE GALLERY FILTER
// Filters product images by the model size tagged in their alt text.
//
// Alt text convention is "sg-10-12 <free text>", but the parser below is
// deliberately forgiving: case, the separator after "sg", and an optional
// "size" word are all tolerated, so sg-10-12 / sg 10-12 / sg10-12 / SG-6-8 /
// sg-size-7-8 all resolve to the same size.
//
// Images are grouped by that parsed size, NOT by the whole alt string, so the
// free text after the size is free to differ between photos of the same model.
// ============================================================

// Pull the size out of an alt string; returns null if it isn't a size-tagged image.
function parse_gallery_size(alt) {
  if (!alt) return null;
  let match = String(alt).trim().match(/^sg[-\s]*(?:size[-\s]*)?(\d+(?:\s*-\s*\d+)?\+?)/i);
  return match ? match[1].replace(/\s+/g, "") : null;
}

function init_product_gallery_filter() {
  // Container for filter buttons added via section block
  let btn_group_dom = document.querySelector(".gallery_alt_filter_block .list");
  if (!btn_group_dom) return;

  // Get all gallery thumbnail buttons
  let gallery_thumb_btn_list = document.querySelectorAll(
    ".hdt-product-media__thumb .hdt-slider__slide"
  );

  // Read the size tagged on each thumbnail (null for untagged images)
  const thumb_size = (thumb) => {
    let img = thumb.querySelector(".hdt-ratio img");
    return img ? parse_gallery_size(img.getAttribute("alt")) : null;
  };

  // Helper: extract first number from string for sorting
  const extractNumber = (str) => {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : Infinity;
  };

  // Unique sizes present on this product, smallest first
  let size_list = Array.from(
    new Set(
      Array.from(gallery_thumb_btn_list)
        .map(thumb_size)
        .filter(Boolean)
    )
  ).sort((a, b) => extractNumber(a) - extractNumber(b));

  // Internal key for a size, also written to the button's data attribute.
  // Keep the "sg-" prefix: new-css.css hides the whole block unless a button
  // carries a data value containing "sg".
  const size_key = (size) => "sg-" + size;

  // One filter button per size
  for (let size of size_list) {
    let key = size_key(size);
    let btn = document.createElement("div");
    btn.setAttribute("class", "item");
    btn.textContent = size;
    btn.setAttribute("data", key);
    btn.addEventListener("click", () => toggle_img(key, true));
    btn.addEventListener("click", () => update_status(key));
    btn_group_dom.appendChild(btn);
  }

  // "View All" button behavior
  let view_all_btn = btn_group_dom.querySelector(".view_all");
  view_all_btn.addEventListener("click", () =>
    toggle_img(view_all_btn.getAttribute("data"), true)
  );
  view_all_btn.addEventListener("click", () =>
    update_status(view_all_btn.getAttribute("data"))
  );

  // Filter thumbnails to one size and optionally click first matching one
  function toggle_img(key, need_click) {
    let has_click = !need_click;

    if (key === "view_all") {
      // Show all thumbnails
      for (let gallery_thumb of gallery_thumb_btn_list) {
        gallery_thumb.style.display = "block";
      }
      // Click the first thumbnail to reset the main image
      if (!has_click && gallery_thumb_btn_list.length > 0) {
        gallery_thumb_btn_list[0].click();
      }
    } else {
      for (let gallery_thumb of gallery_thumb_btn_list) {
        let thumb_sz = thumb_size(gallery_thumb);
        if (thumb_sz && size_key(thumb_sz) === key) {
          gallery_thumb.style.display = "block";
          if (!has_click) {
            gallery_thumb.click();
            has_click = true;
          }
        } else {
          gallery_thumb.style.display = "none";
        }
      }
    }
  }

  // Update active state of filter buttons
  function update_status(key) {
    let btn_list = btn_group_dom.querySelectorAll(".item");
    for (let btn of btn_list) {
      if (btn.getAttribute("data") === key) {
        btn.setAttribute("active", true);
      } else {
        btn.removeAttribute("active");
      }
    }
  }

  // Sync filter when user swipes gallery
  const slider_out_dom = document.querySelector(
    "hdt-product-media .hdt-slider__container"
  );

  function handle_class_change(mutations_list) {
    mutations_list.forEach(mutation => {
      if (
        mutation.type === "attributes" &&
        mutation.target.parentNode === slider_out_dom
      ) {
        if (
          mutation.target
            .getAttribute("class")
            .indexOf("is-selected") >= 0
        ) {
          let slide_img = mutation.target.querySelector("img");
          let size = slide_img
            ? parse_gallery_size(slide_img.getAttribute("alt"))
            : null;
          let active_filter_btn = btn_group_dom.querySelector("[active]");
          if (!active_filter_btn) return;

          // If "view_all" is active, don't switch
          if (active_filter_btn.getAttribute("data") === "view_all") return;

          // If the image isn't size-tagged, reset to "view_all"
          if (!size) {
            toggle_img("view_all", false);
            update_status("view_all");
            return;
          }

          // Switch filter if the slide's size isn't the current filter
          let key = size_key(size);
          if (active_filter_btn.getAttribute("data") !== key) {
            for (let btn of btn_group_dom.querySelectorAll(".item")) {
              if (btn.getAttribute("data") === key) {
                btn.click();
                break;
              }
            }
          }
        }
      }
    });
  }

  // Observe slide selection changes
  const observer = new MutationObserver(handle_class_change);
  observer.observe(slider_out_dom, {
    attributes: true,
    attributeFilter: ["class"],
    subtree: true,
  });
}


// ============================================================
// DOM READY: Initialize features
// ============================================================
function initPageEnhancements() {
  // Initialize product gallery size filter
  init_product_gallery_filter();

  // Move review video to product tab
  const elementVideo = document.querySelector('#review-video');
  const elementTab = document.querySelector('.hdt-product-tab__content .hdt-tab-item .hdt-rte');

  if (elementTab && elementVideo) {
    elementTab.appendChild(elementVideo);
  }

  // Add title & alt attributes to submenu collection images
  function addImageAlt() {
    const collections = document.querySelectorAll('hdt-lazy-submenu .hdt-collection-inner');
    collections.forEach(container => {
      let titleSpan = container.querySelector('.hdt-collection-title-text');
      if (!titleSpan) return;
      let text = titleSpan.textContent.trim();

      // Set img alt
      let img = container.querySelector('.hdt-collection-img img');
      if (img) {
        img.alt = text;
      }

      // Set title on full-width link
      let fullLink = container.querySelector('.hdt-full-width-link');
      if (fullLink) {
        fullLink.title = text;
      }

      // Set title on visible title link
      let titleLink = container.querySelector('.hdt-collection-title');
      if (titleLink) {
        titleLink.title = text;
      }
    });
  }
  // Run immediately in case submenus are already in the DOM, then watch for lazy-loaded ones
  addImageAlt();
  new MutationObserver(() => addImageAlt()).observe(document.body, { childList: true, subtree: true });

  // Hide mega menu '-' placeholder values
  document.querySelectorAll("#hdt-mega- > span > span").forEach(t =>
    t.textContent === '-' && (t.style.display = "none")
  );

  // Coming soon form: capture variant details
  const form = document.querySelector('.coming_soon_form form');
  if (form) {
    var product_textarea = document.querySelector('.coming_soon_form form textarea[name="contact[product]"]');

    // Add color to form
    const colorElement = document.querySelector('.hdt-variant-picker .is-style-color .hdt-font-semibold');
    if (colorElement) {
      const colorInput = document.createElement('input');
      colorInput.type = 'hidden';
      colorInput.name = 'Color';
      colorInput.value = colorElement.textContent.trim();
      form.appendChild(colorInput);
      product_textarea.value += '\n Color: ' + colorElement.textContent.trim();
    }

    // Add cup size to form
    const cupElement = document.querySelector('.cup-size input[name="Cup"]:checked');
    if (cupElement) {
      const cupInput = document.createElement('input');
      cupInput.type = 'hidden';
      cupInput.name = 'CupSize';
      cupInput.value = cupElement.value;
      form.appendChild(cupInput);
      product_textarea.value += '\n Cup Size: ' + cupElement.value;
    }

    // Add band size to form
    const bandElement = document.querySelector('.band-size input[name="Band"]:checked');
    if (bandElement) {
      const bandInput = document.createElement('input');
      bandInput.type = 'hidden';
      bandInput.name = 'BandSize';
      bandInput.value = bandElement.value;
      form.appendChild(bandInput);
      product_textarea.value += '\n Band Size: ' + bandElement.value;
    }

    // Add variant ID from URL
    let selected_variant = getVariantFromURL();
    if (selected_variant) {
      product_textarea.value += '\n Variant ID: ' + selected_variant;
    }

    // Listen for variant changes
    const cupRadios = document.querySelectorAll('.cup-size input[name="Cup"]');
    const bandRadios = document.querySelectorAll('.band-size input[name="Band"]');

    cupRadios.forEach(radio => {
      radio.addEventListener('click', update_coming_soon_form);
    });

    bandRadios.forEach(radio => {
      radio.addEventListener('click', update_coming_soon_form);
    });
  }

  // Cart page: trigger checkbox change event
  const url = window.location.href;
  if (url.includes('cart')) {
    setTimeout(function() {
      const checkbox = document.querySelector('input[name="agree_checkbox"]');
      if (checkbox && checkbox.checked) {
        const changeEvent = new Event('change', { bubbles: true });
        checkbox.dispatchEvent(changeEvent);
        checkbox.checked = false;
        checkbox.checked = true;
      }
    }, 1000);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPageEnhancements);
} else {
  initPageEnhancements();
}


// ============================================================
// HELPER FUNCTIONS
// ============================================================

function update_coming_soon_form() {
  const form = document.querySelector('.coming_soon_form form');
  if (!form) return;

  var product_textarea = document.querySelector('.coming_soon_form form textarea[name="contact[product]"]');
  product_textarea.value = product_textarea.value.split('\n')[0];

  const colorElement = document.querySelector('.hdt-variant-picker .is-style-color .hdt-font-semibold');
  if (colorElement) {
    product_textarea.value += '\n Color: ' + colorElement.textContent.trim();
  }

  const cupElement = document.querySelector('.cup-size input[name="Cup"]:checked');
  if (cupElement) {
    product_textarea.value += '\n Cup Size: ' + cupElement.value;
  }

  const bandElement = document.querySelector('.band-size input[name="Band"]:checked');
  if (bandElement) {
    product_textarea.value += '\n Band Size: ' + bandElement.value;
  }

  let selected_variant = getVariantFromURL();
  if (selected_variant) {
    product_textarea.value += '\n Variant ID: ' + selected_variant;
  }
}

function getVariantFromURL() {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get('variant');
}


// ============================================================
// MOBILE FILTER DRAWER FIX
// Prevents drawer from auto-opening on mobile search pages
// ============================================================

function isTargetScreenSize() {
  return window.innerWidth < 1150;
}

function removeDrawerAttributes() {
  if (!isTargetScreenSize()) return;

  const drawerElement = document.querySelector('.search_page_wrapper .hdt-shop-sidebar .hdt-drawer');

  if (drawerElement) {
    drawerElement.removeAttribute('open-dialog');
    drawerElement.removeAttribute('open');
  }
}

// Run immediately
removeDrawerAttributes();

// Watch for attributes being added back
const drawerObserver = new MutationObserver(function(mutations) {
  if (!isTargetScreenSize()) return;

  mutations.forEach(function(mutation) {
    if (mutation.type === 'attributes') {
      const target = mutation.target;

      if (target.matches('.search_page_wrapper .hdt-shop-sidebar .hdt-drawer')) {
        if (target.hasAttribute('open-dialog')) {
          target.removeAttribute('open-dialog');
        }
        if (target.hasAttribute('open')) {
          target.removeAttribute('open');
        }
      }
    }
  });
});

// Start observing
const targetElement = document.querySelector('.search_page_wrapper .hdt-shop-sidebar .hdt-drawer');
if (targetElement) {
  drawerObserver.observe(targetElement, {
    attributes: true,
    attributeFilter: ['open-dialog', 'open']
  });
}

// Listen for resize events
window.addEventListener('resize', removeDrawerAttributes);


// ============================================================
// STORE LOCATOR: Style store visit buttons
// ============================================================
let storeItem = document.querySelectorAll('.hdt-store-info .hdt-tab-item');
storeItem.forEach((item) => {
  let storeBtn = item.querySelector('a[href*="-store"]');
  if (storeBtn != null) {
    storeBtn.style.border = "1.5px solid #000";
    storeBtn.style.padding = '8px 16px';
    storeBtn.style.display = 'inline-block';
    storeBtn.style.borderRadius = "3px";
    storeBtn.style.fontWeight = '600';
    storeBtn.style.fontSize = '16px';
    storeBtn.parentNode.style.marginTop = "25px";
    let infoContainer = item.querySelector('.hdt-store-item-info');
    infoContainer.appendChild(storeBtn.parentNode);
  }
});
